import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'

import { useFormContext } from 'react-hook-form'
import { IconButton, SvgIcon, Badge, Tooltip } from '@mui/material'
import { ReactComponent as RouteIcon } from 'assets/Route.svg'

import { get } from 'utils/lodash'

import EventBlocker from 'components/common/EventBlocker'
import FilterMenuField from '../common/FilterMenuField'
import RenderFilterOption from './RenderFilterOption'
import { isSameAction } from '../utils'

const BUTTON_CLASS_NAME = 'wo-route-filter'

const FiltersMenuButton = ({ sx }) => {
  const { control, watch, setValue } = useFormContext()
  const searchRoutesInput = watch('searchRoutesInput')
  const routesOptions = watch('routesOptions')
  const selectedRoutes = watch('selectedRoutes')
  const selectedCount = useMemo(() => get(selectedRoutes, 'length', 0), [selectedRoutes])
  const [anchorEl, setAnchorEl] = useState(null)

  const handleRoutesSearchInputChange = (_, value, reason) => {
    if (reason !== 'reset') {
      setValue('searchRoutesInput', value)
    }
  }

  const handleClose = event => {
    if (isSameAction(event, BUTTON_CLASS_NAME)) {
      return
    }
    setAnchorEl(null)
  }

  const handleClick = event => {
    event.stopPropagation()
    if (anchorEl) {
      handleClose()
      return
    }
    setAnchorEl(event.currentTarget)
  }

  const isOpen = Boolean(anchorEl)

  return (
    <EventBlocker>
      <Tooltip title="Routes" arrow placement="top">
        <IconButton className={BUTTON_CLASS_NAME} sx={sx} onClick={handleClick}>
          <Badge badgeContent={selectedCount} color="primary">
            <SvgIcon>
              <RouteIcon color="primary" />
            </SvgIcon>
          </Badge>
        </IconButton>
      </Tooltip>
      {isOpen && (
        <FilterMenuField
          control={control}
          anchorEl={anchorEl}
          name="selectedRoutes"
          label="Routes"
          inputValue={searchRoutesInput}
          onInputChange={handleRoutesSearchInputChange}
          options={routesOptions}
          renderOption={RenderFilterOption}
          onClose={handleClose}
          width={250}
          boxRestProps={{ right: 60 }}
        />
      )}
    </EventBlocker>
  )
}

FiltersMenuButton.propTypes = {
  sx: PropTypes.object,
}

export default FiltersMenuButton
